import api from "shared/api";
import { LicenseRaw } from "./models";

const prefix = "api/compendalicense";

export const getLicenseForCurrentUser = async (): Promise<LicenseRaw> => {
  try {
    const res = await api().get<LicenseRaw>(`${prefix}/current-user`);
    return res.data;
  } catch (e) {
    throw e;
  }
};
